import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UploadSourceFileParams {
  loanId: string;
  file: File;
}

export interface UploadSourceFileResponse {
  message: string;
  sourceFileId: string;
}

const uploadSourceFile: MutationFunction<
  UploadSourceFileResponse,
  UploadSourceFileParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockUploadSourceFile, { delay: 100 });

  const formData = new FormData();
  formData.append('files', args.file);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UploadSourceFileResponse>(
    `/loans/${args.loanId}/source-files`,
    {
      method: 'POST',
      body: formData,
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to upload document');
};

export default uploadSourceFile;

const _mockUploadSourceFile = {
  message: 'Source file uploaded successfully',
  sourceFileId: 'e727ftx2ctfasa91bun9p38f',
};
